import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

import { Parallax } from "react-scroll-parallax"
import { HashLink as Link } from "react-router-hash-link"

import Badge from "@material-ui/core/Badge"
import ShoppingCart from "@material-ui/icons/ShoppingCartOutlined"

import Modal from "@material-ui/core/Modal"
import Backdrop from "@material-ui/core/Backdrop"
import Fade from "@material-ui/core/Fade"
import ReactCountryFlag from "react-country-flag"

import BurgerMenu from "../BurgerMenu/BurgerMenu"

import { selectCartCount } from "../../redux/cart/cart.selectors"
import { selectLanguage } from "../../redux/language/language.selectors"
import { selectCurrentUser } from "../../redux/user/user.selectors"

import { setCurrentUser } from "../../redux/user/user.actions"
import { setLanguage } from "../../redux/language/language.actions"

import EN_DATA from "../../data/language/english.data"
import PT_DATA from "../../data/language/portuguese.data"

import Logo from "../../assets/images/head-start-branco.png"

import "./Header.scss"

function Header({
  cartCount,
  language,
  currentUser,
  setCurrentUser,
  setLanguage,
}) {
  const menu = language === "EN" ? EN_DATA.menu : PT_DATA.menu

  // LANGUAGE MODAL (ONLY HERE)
  const [openLangModal, setOpenLangModal] = useState(false)

  useEffect(() => {
    const savedLang = localStorage.getItem("language")

    if (savedLang && (!language || language !== savedLang)) {
      setLanguage(savedLang)
      setOpenLangModal(false)
      return
    }

    if (!savedLang && !language) {
      setOpenLangModal(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleCloseLang = () => setOpenLangModal(false)

  const handleLanguage = (lang) => {
    setLanguage(lang)
    localStorage.setItem("language", lang)
    setOpenLangModal(false)
  }

  // MENU STATE (unchanged)
  const [home, setHome] = useState(true)
  const [about, setAbout] = useState(false)
  const [services, setServices] = useState(false)
  const [gallery, setGallery] = useState(false)
  const [contact, setContact] = useState(false)
  const [login, setLogin] = useState(false)
  const [dash, setDash] = useState(false)
  const [report, setReport] = useState(false)
  const [cart, setCart] = useState(false)

  function setAllFalse() {
    setHome(false)
    setAbout(false)
    setServices(false)
    setGallery(false)
    setContact(false)
    setLogin(false)
    setDash(false)
    setReport(false)
    setCart(false)
  }

  function setOption(option) {
    setAllFalse()
    if (option === "home") setHome(true)
    if (option === "about") setAbout(true)
    if (option === "services") setServices(true)
    if (option === "gallery") setGallery(true)
    if (option === "contact") setContact(true)
    if (option === "login") setLogin(true)
    if (option === "dash") setDash(true)
    if (option === "report") setReport(true)
    if (option === "cart") setCart(true)
  }

  function handleLogout() {
    setCurrentUser()

    // ✅ Don't wipe language preference
    const keepLanguage = localStorage.getItem("language")
    localStorage.clear()
    if (keepLanguage) localStorage.setItem("language", keepLanguage)
    // No need to set badge state; Redux cart will drive the badge.
  }

  return (
    <div>
      <div className="header">
        <Link
          className="logo-container"
          onClick={() => window.scrollTo(0, 0)}
          to="/"
        >
          <Parallax y={[-40, 0]}>
            <img src={Logo} alt="Head Start" />
          </Parallax>
        </Link>

        <div className="options">
          <Link
            className={`option ${home ? "line-bottom" : ""}`}
            onClick={() => {
              setOption("home")
              window.scrollTo(0, 0)
            }}
            to="/"
          >
            {menu[0]}
          </Link>

          <Link
            className={`option ${services ? "line-bottom" : ""}`}
            onClick={() => setOption("services")}
            to="/#services"
          >
            {menu[1]}
          </Link>

          <Link
            className={`option ${about ? "line-bottom" : ""}`}
            onClick={() => setOption("about")}
            to="/#about-us"
          >
            {menu[2]}
          </Link>

          <Link
            className={`option ${gallery ? "line-bottom" : ""}`}
            onClick={() => setOption("gallery")}
            to="/gallery"
          >
            {menu[3]}
          </Link>

          <Link
            className={`option ${contact ? "line-bottom" : ""}`}
            onClick={() => setOption("contact")}
            to="/#contact"
          >
            {menu[4]}
          </Link>

          {currentUser ? (
            <Link
              className={`option ${dash ? "line-bottom" : ""}`}
              onClick={() => setOption("dash")}
              to="/dashboard"
            >
              {currentUser?.type === 0 ? "ADMIN" : menu[7]}
            </Link>
          ) : (
            ""
          )}

          {currentUser ? (
            <Link
              className={`option ${login ? "line-bottom" : ""}`}
              onClick={handleLogout}
              to="/"
            >
              {menu[6]}
            </Link>
          ) : (
            <Link
              className={`option ${login ? "line-bottom" : ""}`}
              onClick={() => setOption("login")}
              to="/login"
            >
              {menu[5]}
            </Link>
          )}

          {/* Language flags + label */}
          <div className="option header-language">
            <div
              className={`lang-item ${language === "EN" ? "active" : ""}`}
              onClick={() => handleLanguage("EN")}
            >
              <ReactCountryFlag
                countryCode="IE"
                svg
                style={{ fontSize: "1.6em", lineHeight: "1.6em" }}
              />
              <span className="lang-label">EN</span>
            </div>

            <div
              className={`lang-item ${language === "BR" ? "active" : ""}`}
              onClick={() => handleLanguage("BR")}
            >
              <ReactCountryFlag
                countryCode="BR"
                svg
                style={{ fontSize: "1.6em", lineHeight: "1.6em" }}
              />
              <span className="lang-label">PT-BR</span>
            </div>
          </div>

          <Link
            className={`option ${cart ? "line-bottom" : ""}`}
            onClick={() => setOption("cart")}
            to="/cart"
          >
            <Badge badgeContent={cartCount} color="primary">
              <ShoppingCart />
            </Badge>
          </Link>
        </div>

        <BurgerMenu onLanguage={handleLanguage} />
      </div>

      {/* Language modal ONLY here */}
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        className="item-modal"
        open={openLangModal}
        onClose={handleCloseLang}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={openLangModal}>
          <div className="paper">
            <h2 id="modal-title">Select Language</h2>

            <div id="modal-description">
              <ReactCountryFlag
                className="item-flag"
                countryCode="IE"
                aria-label="English"
                title="English"
                style={{
                  fontSize: "6em",
                  lineHeight: "6em",
                  cursor: "pointer",
                }}
                svg
                onClick={() => handleLanguage("EN")}
              />
              <ReactCountryFlag
                className="item-flag"
                countryCode="BR"
                aria-label="Portuguese"
                title="Portuguese"
                style={{
                  fontSize: "6em",
                  lineHeight: "6em",
                  cursor: "pointer",
                }}
                svg
                onClick={() => handleLanguage("BR")}
              />
            </div>

            <div className="modal-label">
              <div>English</div>
              <div>Portuguese</div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
  cartCount: selectCartCount, // ✅ quantity-based count
  language: selectLanguage,
})

const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
  setLanguage: (lang) => dispatch(setLanguage(lang)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Header)
